export default "skymp5-front/fbccf4a8d2c044b5f7e1f1d7dbccdd55.png";